import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { BidMetricsByDim, MappedName } from '@pubstack/common/src/analytics/query'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import { FunctionComponent } from 'react'
import { useAnalyticsQueryTanstack } from '~/api/analytics/analytics-query.api'
import { Context } from '~/state'
import { TabConfig } from '~/utils/analytics'
import { PureBidderBreakdown } from './PureBidderBreakdown'

type BidderBreakdownProps = {
  context: Context
  dimensions: Dimension[]
  dimension: Dimension
  bidder: string
  currencySymbol: CurrencySymbol
  onTabChange: (dimension: Dimension) => void
  onRowClick: (name: MappedName) => void
  tabsConfig: TabConfig[]
}

export const BidderBreakdown: FunctionComponent<BidderBreakdownProps> = ({ context, dimensions, dimension, bidder, currencySymbol, onTabChange, onRowClick, tabsConfig }) => {
  const analyticsQuery = useAnalyticsQueryTanstack<BidMetricsByDim>('bid.metrics.by.dim', dimensions, context, { bidderName: bidder, dimension })

  return (
    <PureBidderBreakdown
      isLoading={analyticsQuery.isFetching}
      error={!!analyticsQuery.error}
      empty={!analyticsQuery.isLoading && !analyticsQuery.data?.name?.length}
      onRefreshClick={() => analyticsQuery.refetch()}
      rawData={analyticsQuery.data}
      onTabChange={onTabChange}
      currencySymbol={currencySymbol}
      onRowClick={onRowClick}
      onSortChange={() => {}}
      tabsConfig={tabsConfig}
    />
  )
}
